module.exports = __webpack_public_path__ + "img/DW365-100.3f39d4c2.jpg";